/**
 * In Progress...
 * @author Parag Majumdar
 * @desc Site-wide user singleton
 * @depends Cookies
 * @usage
 *    var User = CT.User.getInstance() // gives you the user singleton
 */
!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('libs/ct_user',['libs/ct_store', 'vendor/cookies', 'libs/ct_pubsub'], module)
	else
	//>>excludeEnd("requireTmpl"); 
		context[name] = module(CT.Store, Cookies)
}('User', function(Store, Cookies){
	var User = (function() {

		// Instance stores a reference to the User singleton
		var instance;
	
		function init(o) {
			var obj = {}
			var u = Cookies.get('user')
			if(obj.isLoggedIn = u? true : false)
				for(var key in u){
					obj[key] = u[key]
				}
	
			if(o)
				for(var key in o){
					obj[key] = o[key]
				}
			obj.update = function(opts){
				//TODO
			}
			
			return obj
		}
	
		return {
			init : function(opts) {
				if (!instance)
					instance = init(opts);
				return instance;
			},
			
			getInstance : function() {
				if (!instance)
					instance = init();
				return instance;
			},
			
			destroy : function(){
				try{ // try logout
					CT.fire('logout', [this.getInstance()])
					for(var key in instance)
						delete instance[key]
					instance = null
					Cookies.expire('user')
					return true
				} catch(e){ // Could not logout
					return false
				}
			}
		}
	
	})();
	
	return User
}, CT);
